import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Checkbox');

const propTypes = {
    id: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.string,
    render: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    isCheckoutLayout: PropTypes.bool,
};

const defaultValues = {
    checked: false,
};

function Checkbox(props) {
    const { checked, children, className, hasError, id, isCheckoutLayout, render, value, ...rest } = props; // eslint-disable-line no-unused-vars

    return (
        <div className={bem(null, { isCheckoutLayout }, className)}>
            <div className={bem('input', [hasError && 'error', isCheckoutLayout ? 'isCheckoutLayout' : ''])}>
                <input checked={checked || value === true} id={id} type="checkbox" {...rest} />
            </div>
            {children ? (
                <label className={bem('label')} htmlFor={id}>
                    {children}
                </label>
            ) : null}
            {typeof render === 'function' ? render(props) : render}
        </div>
    );
}

Checkbox.propTypes = propTypes;
Checkbox.defaultValues = defaultValues;

export default Checkbox;
